import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useViewport } from '@/lib/viewport';
import { useScope } from '@/lib/scope';
import { TopNav } from './TopNav';
import { Sidebar } from './Sidebar';

export function AppLayout() {
  const { isMobile, isTablet } = useViewport();
  const { role } = useScope();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarDrawerOpen, setSidebarDrawerOpen] = useState(false);
  const [, setCmdkOpen] = useState(false);

  useEffect(() => {
    if (isTablet) setSidebarCollapsed(true);
  }, [isTablet]);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setCmdkOpen((o) => !o);
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', minHeight: 0 }}>
      <TopNav
        onOpenCmdK={() => setCmdkOpen((o) => !o)}
        onOpenSidebar={() => setSidebarDrawerOpen(true)}
      />
      <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
        {!isMobile && (
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggle={() => setSidebarCollapsed((v) => !v)}
            role={role}
          />
        )}
        {isMobile && (
          <Sidebar
            collapsed={false}
            onToggle={() => undefined}
            role={role}
            drawerOpen={sidebarDrawerOpen}
            onCloseDrawer={() => setSidebarDrawerOpen(false)}
            isMobile
          />
        )}
        <main
          style={{
            flex: 1,
            minWidth: 0,
            background: 'var(--bx-page-bg)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
